import { render, staticRenderFns } from "./advertiser-vertical.vue?vue&type=template&id=6489fbe9&scoped=true"
import script from "./advertiser-vertical.vue?vue&type=script&lang=js"
export * from "./advertiser-vertical.vue?vue&type=script&lang=js"
import style0 from "./advertiser-vertical.vue?vue&type=style&index=0&id=6489fbe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489fbe9",
  null
  
)

export default component.exports